var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-layer"},[_c('img',{staticClass:"layer-close",attrs:{"src":_vm.closeBtnGrayPic},on:{"click":_vm.handleClose}}),_c('div',{staticClass:"layer-content"},[_vm._t("context")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }